import { Typography } from "@mui/material";
import React from "react";
import CookieConsent from "react-cookie-consent";
import './cookiesConsent.scss';
import { EnableCookies } from "./enableCookies.tsx/enableCookies";
import { RejectCookiesConsent } from "./rejectCookies/rejectCookies";
import Cookies from "js-cookie";
import { useCookies } from "react-cookie";

export const CookiesConsent: React.FC<any> = () => {
  const [rejectCookies, setRejectCoookies] = React.useState(false);
  const [enableCookiePopup, setEnableCookiePopup] = React.useState(false)
  const [cookies, setCookie] = useCookies<any>();
  const enableCookie = Cookies.get("enableCookies")

  let expire = new Date();
  let days: any = 365;
  expire.setTime(+ expire + (days * 86400000));

  const acceptButtonCall = () => {
    if (navigator.cookieEnabled && (enableCookie === "false" || enableCookie === undefined)) {
      setCookie('enableCookies', true, { path: '/', expires: expire });
    }
    else {
      setEnableCookiePopup(true)
    }
  }

  const rejectButtonCall = () => {
    setRejectCoookies(true)
  }

  return (
    <div className="cookiesConsentWrapper">
      <CookieConsent
        containerClasses="cookiesConsent"
        debug={true}
        location="bottom"
        cookieName="enableCookies"
        enableDeclineButton
        declineButtonText="Reject cookies"
        declineButtonClasses="declineButton"
        buttonText="Accept cookies"
        overlay
        buttonClasses='acceptButton'
        contentClasses="contentClass"
        onDecline={rejectButtonCall}
        onAccept={acceptButtonCall}
        buttonWrapperClasses={navigator.cookieEnabled ? "removeBorder" : "buttonWrapper"}
      >
        <div className="contentClassWrapper">
          <div className="cookiesTopContent">
            <div className="cookiesTitle">
              <span > Infraclear Inc. requires the use of cookies when you visit our website. Cookies are small files placed by your browser on the device you use to access the internet.
                We use:</span>
            </div>
            <div className="cookiesList" >
              <Typography className="unorderList"> <span className="textBold">Strictly Necessary Cookies : </span>  These cookies allow you to move through our site without having to sign in again at each page and are necessary for our website to function.</Typography>
              <Typography className="unorderList"> <span className="textBold">Functional Cookies : </span>  These cookies allow us to keep the settings you have set, such as language, time zone, and other preferences and enable the basic operation of our site.  Without these cookies, certain services of our website may not function correctly.</Typography>
            </div>
            <div className="cookiesList" >
              <Typography className="unorderList">By clicking Accept, you consent to our use of strictly necessary and functional cookies.</Typography>
              <Typography className="unorderList"> By clicking Reject, you do not consent to our use of strictly necessary and functional cookies and will not be able to use our website or online services. </Typography>
            </div>
            <div className="cookiesList" >
              <Typography className="unorderList">We care about your privacy. Please see our <a href="https://infraclear.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy </a> if you have any questions about how we use your information.</Typography>
            </div>
          </div>
        </div>
      </CookieConsent>
      {rejectCookies &&
        <RejectCookiesConsent />
      }
      {
        enableCookiePopup &&
        <EnableCookies />
      }
    </div>
  );
};